@for (toast of toasts; track toast) {
  <div
    class="x_alert"
    [ngClass]="toast.level"
    [@fadeInOut]
    [attr.e2e-attr]="E2E_ATTRIBUTES.TOAST_NOTIFICATION"
  >
    <i class="x_alert-icon" [ngClass]="toast.level | iconClass"></i>
    <span class="x_alert-type">{{
      getToastTitle(toast.level) | translate
    }}</span>
    <span class="x_alert-message">{{ toast.message | translate }}</span>
    @if (toast.closeOnTimerOrButton) {
      <span class="x_alert-button-close" (click)="onClose(toast)">
        <i
          class="icon-close"
          [attr.e2e-attr]="E2E_ATTRIBUTES.TOAST_NOTIFICATION_ICON_CANCEL"
        ></i>
      </span>
    }
  </div>
}
